import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafPercentBar } from '@cigna/leaf-web/lib/wc';

import '@cigna/leaf-web/lib/wc/components/percent-bar/percent-bar';

@Component({
  selector: 'cigna-leaf-percent-bar',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-percent-bar
      [value]="value"
      [max]="max"
      [disableActionLeft]="disableActionLeft"
    >
    </leaf-percent-bar>
  `,
})
export class CignaLeafPercentBarComponent {
  @Input() value: LeafPercentBar['value'];
  @Input() max: LeafPercentBar['max'];
  @Input() disableActionLeft: LeafPercentBar['disableActionLeft'];
}
